import React from 'react';

interface SendMessageConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const SendMessageConfig: React.FC<SendMessageConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Envia uma mensagem de texto simples para o usuário. Você pode incluir variáveis usando <code className="bg-blue-100 px-1 rounded">{'{{nome_variavel}}'}</code> que serão substituídas pelo valor real na hora do envio. O fluxo segue automaticamente para o próximo nó.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Mensagem
        </label>
        <textarea
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={4}
          placeholder="Digite a mensagem..."
          value={config.message || ''}
          onChange={(e) => onChange('message', e.target.value)}
        />
      </div>
    </div>
  );
};
